import { z } from "zod";
import {
  sseChunkSchema,
  sseDoneSchema,
  sseErrorSchema,
  sseRestartSchema,
  sseStartSchema,
  sseToolResultSchema,
  sseToolSchema,
} from "./sseEventSchemas";

export const sseEventSchema = z.discriminatedUnion("type", [
  sseStartSchema,
  sseChunkSchema,
  sseToolSchema,
  sseToolResultSchema,
  sseDoneSchema,
  sseRestartSchema,
  sseErrorSchema,
]);

export function parseSseEvent(raw) {
  const result = sseEventSchema.safeParse(raw);
  if (result.success) return result.data;
  if (import.meta.env?.DEV) {
    console.warn("[phase1-sse] schema mismatch", result.error.issues, raw);
  }
  return raw;
}
